import React, { useState, useEffect, useRef } from "react";
import PortableText from "./portableText";
import clientConfig from "../../client-config";
import VideoModal from "./videoModal";
import Helmet from 'react-helmet';
import * as styles from './homeHero.module.css';
import { gsap, TweenMax, Expo } from "gsap";

import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";



const maybeImage = illustration => {
    let img = null;
    if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
        const imageData = getGatsbyImageData(
        illustration.image,
        { maxWidth: 960 },
        clientConfig.sanity
        );
    
        img = (
        <GatsbyImage
            image={imageData}
            alt={illustration.image.alt}
        />
        );
    }
    return img;
};

function HomeHero(props) {

    let heroBg = (props.backgroundImage) ? props.backgroundImage.image.asset.url : '';

    let hasWistia = (props.wistiaId) ? true : false;

    let desktopBgClass = styles.sectionBg + ' ' +styles.sectionBgDesktop;
    let mobileBgClass = styles.sectionBg + ' ' +styles.sectionBgMobile;

    let containerClass = styles.sectionContainer + ' mx-auto';

    const [videoModalOpen, setVideoModalOpen] = useState(false);
    const [videoSrc, setVideoSrc] = useState(props.videoLink);

    let openVideoModal = () => {
        setVideoSrc(props.videoLink);
        setVideoModalOpen(true);
    }

    let closeVideoModal = () => {
        setVideoModalOpen(false);
        setVideoSrc('');
    }

    const featuredimg = maybeImage(props.image);
    let bgImageDesktop = (props.bgimagedesktop) ? ( (props.bgimagedesktop.image) ? props.bgimagedesktop.image.asset.url : false) : false;
    let bgImageMobile = (props.bgimagemobile) ? ( (props.bgimagemobile.image) ? props.bgimagemobile.image.asset.url : bgImageDesktop) : bgImageDesktop;
    let bgColor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';

    const sectionRef = useRef();
    const titleRef = useRef();
    const contentRef = useRef();
    const ctaRef = useRef();
    const bgRef = useRef();
    const wistiaRef = useRef();

    useEffect(() => {
        // TweenMax.set([titleRef.current, contentRef.current, ctaRef.current], {
        //     opacity: 0,
        //     y: 100
        // });
        // TweenMax.to(
        //     titleRef.current, 
        //     0.45, 
        //     { 
        //         opacity: 1, 
        //         y: -25, 
        //         delay : 0.35, 
        //         onComplete : () => {
        //             TweenMax.to(
        //                 titleRef.current,
        //                 0.3,
        //                 {
        //                     y: 0,
        //                 }
        //             )
        //         }
        //     } 
        // );
        // TweenMax.to(
        //     contentRef.current, 
        //     0.45, 
        //     { 
        //         opacity: 1, 
        //         y: -25, 
        //         delay : 0.55, 
        //         onComplete : () => {
        //             TweenMax.to(
        //                 contentRef.current,
        //                 0.3,
        //                 {
        //                     y: 0,
        //                 }
        //             )
        //             $(sectionRef.current).addClass('anim-complete');
        //         }
        //     } 
        // );
        
        // TweenMax.to(
        //     ctaRef.current, 
        //     0.45, 
        //     { 
        //         opacity: 1, 
        //         y: 0, 
        //         delay : 0.75
        //     } 
        // );

        if(!$(sectionRef.current).hasClass('anim-complete')){
            let scroll_factor = 3;
            let scroll_limit = 85;
            $(sectionRef.current).addClass('anim-complete');

            $(window).on('scroll', () => {
                let scroll_pos = $(window).scrollTop();
                let move_by = (scroll_pos / scroll_factor);
                move_by = (move_by >= scroll_limit) ? scroll_limit : move_by;
                TweenMax.to(bgRef.current, 0.25, {
                    y : 0 - move_by
                });
            });
        }

        if(!$(wistiaRef.current).hasClass('embed-initialized') && hasWistia){
            $(wistiaRef.current).addClass('embed-initialized')
            $(wistiaRef.current).html('<script src="https://fast.wistia.com/embed/medias/'+props.wistiaId+'.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script><div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_'+props.wistiaId+' videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/'+props.wistiaId+'/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>');
        }

    });

    let sectionContentClass = (hasWistia) ? styles.sectionContent+' '+styles.sectionContent__wistia : styles.sectionContent;
    let sectionCTAsClass = (hasWistia) ? styles.sectionCTAs+' '+styles.sectionCTAs__wistia : styles.sectionCTAs;

    return (
        <>
            <Helmet
                bodyAttributes={{
                    class: 'leading-normal tracking-normal home-hero-enabled'
                }}
            />
            <div className={styles.sectionHomeHero} style={{ backgroundColor: `${bgColor}`}} ref={sectionRef}>

                {
                    (bgImageDesktop && !hasWistia) ?
                    <div className={styles.bgImageDesktop} ref={bgRef} style={{ backgroundImage : `url("${bgImageDesktop}")`}}>
                    </div>
                    : ``
                }

                {
                    (bgImageMobile && !hasWistia) ?
                    <div className={styles.bgImageMobile} style={{ backgroundImage : `url("${bgImageMobile}")`}}>
                    </div>
                    : ``
                }
                
                <div className={styles.innerWrap}>
                    <div className={styles.bannerWrap}>
                        <div className={containerClass}>
                            <div className={styles.sectionContentWrap}>
                                <div className={sectionContentClass}>
                                    <div className={styles.sectionTexts}>
                                        <h1 ref={titleRef}>
                                            <PortableText blocks={props.heading} />
                                        </h1>
                                        <div ref={contentRef} className={styles.contentWrap}>
                                            <PortableText blocks={props.content} />
                                        </div>
                                    </div>
                                    <div ref={ctaRef} className={sectionCTAsClass}>
                                        {
                                            (props.cta_label) ?
                                            <div>
                                                <a href={props.cta_link} className={styles.desktopLink}>
                                                    <span>{props.cta_label}</span>
                                                </a>
                                            </div>
                                            : ``
                                        }
                                        {
                                            (props.video_cta_label) ?
                                            <div>
                                                <a href="javascript:void(0);" className={styles.watchBtn} onClick={openVideoModal}>
                                                    <span>{props.video_cta_label}</span>
                                                </a>
                                            </div>
                                            : ``
                                        }
                                    </div>
                                </div>
                                {
                                    (hasWistia) ? 
                                    <div className={styles.wistiaCol}>
                                        <div className={styles.wistiaWrapper} ref={wistiaRef}>
                                        </div>
                                    </div>
                                    : ``
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <VideoModal videoSrc={videoSrc} isOpen={videoModalOpen} closeVideoModal={closeVideoModal} />
        </>
    );
}

export default HomeHero;
